export const conversations = {
  name: "Conversations",
  tabs: {
    all: "All",
    mine: "Mine",
    unassigned: "Unassigned",
  },
  filters: {
    search: "Search conversations...",
    advanced: "Advanced Filters",
    status: "Status",
    priority: "Priority",
    queue: "Queue",
    channel: "Channel",
    assignment: "Assignment",
    assignmentAll: "All",
    assignmentMine: "Assigned to me",
    assignmentUnassigned: "Unassigned",
  },
  sort: {
    lastActivity: "Last activity",
    createdDate: "Created date",
  },
  createConversation: "New conversation",
  empty: {
    title: "No conversations",
    subtitle: "Start a new conversation to get started",
  },
  details: {
    title: "Details",
    userInfo: "User Information",
    contactInfo: "Contact Information",
    ticketInfo: "Ticket Information",
    conversationInfo: "Conversation Information",
    noTicket: "No active ticket",
    quickActions: "Quick Actions",
  },
};

export const conversation = {
  name: "Conversation |||| Conversations",
  fields: {
    subject: "Subject",
    status: "Status",
    source: "Source",
    channel: "Channel",
    contact: "Contact",
    lastMessage: "Last message",
    lastMessageAt: "Last message at",
    lastActivityAt: "Last activity",
    phoneNumber: "Phone Number",
    contactName: "Contact Name",
    instagramUserId: "Instagram User ID",
    selectContact: "Select Contact",
    createdAt: "Created at",
    updatedAt: "Updated at",
  },
  tabs: {
    chat: "Chat",
    details: "Details",
  },
  actions: {
    viewConversation: "View conversation",
    create: "Start conversation",
  },
  dialogs: {
    create: {
      title: "Start conversation",
      subtitle: "Choose the type of conversation you want to start",
      selectType: "Conversation Type",
      channel: "Channel",
      channelHelper: "WhatsApp, Instagram, etc.",
    },
  },
  channelTypes: {
    zapy: "Zapy (WhatsApp)",
    zapyHelper:
      "Start a WhatsApp conversation. Enter the phone number in international format.",
    telegram: "Telegram",
    telegramHelper:
      "Telegram does not allow initiating conversations. Only contacts who have already messaged the bot can be selected.",
    whatsappOfficial: "WhatsApp Official",
    whatsappOfficialHelper:
      "Start a WhatsApp conversation. Enter the phone number in international format.",
    instagram: "Instagram",
    instagramHelper:
      "Start an Instagram DM conversation. Enter the Instagram user ID.",
    webchat: "Webchat",
    webchatHelper:
      "Create a webchat conversation. Optionally provide contact name.",
  },
  zapy: {
    searching: "Searching for contact...",
    newContact: "No existing contact found for this number. You can optionally provide a name for the new contact.",
    nameHelper: "Optional. A name to identify this contact.",
  },
  telegram: {
    noContacts:
      "No contacts found. Only users who have already messaged this bot can receive tickets.",
    noMatchingContacts: "No matching contacts found",
  },
  helpers: {
    phoneNumber: "International format: +5511999999999",
    contactName: "Name to display for this contact",
    instagramUserId: "The Instagram user's unique ID",
    selectContact:
      "Select an existing contact to start the conversation",
    telegramContact:
      "Search by name for contacts who have started a conversation with the bot",
  },
  inputMode: {
    phone: "New Number",
    contact: "Existing Contact",
  },
  errors: {
    noConnectionAvailable:
      "No connection available for this channel. Configure a connection before starting a conversation.",
    noConnection: "No connection",
    noContact: "Select a contact to create the ticket",
    unsupportedChannel:
      "Channel type not supported for ticket creation",
  },
  noActiveConnection:
    "No active connection found for this channel. Check if WhatsApp is connected.",
  noContacts:
    "No contacts found. You can enter a new phone number instead.",
  empty: "No conversations",
  noSearchResults: "No conversations found",
  search: "Search conversations...",
  info: "Conversation info",
  source: "Source",
  createdAt: "Created at",
  crossTenant: "Cross-Tenant",
  sources: {
    inbound: "Inbound",
    outbound: "Outbound",
  },
  participantRole: {
    owner: "Owner",
    participant: "Participant",
    admin: "Administrator",
    agent: "Agent",
  },
};
